import { useState } from 'react'
import { RiLock2Line } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from 'react-router-dom';

import './css/perm.css'

export default function Permission_pop() {

    const { t } = useTranslation();
    let navigate = useNavigate();

    return (
        <div className='noPermssionsBox popup'>
            <div>

                <RiLock2Line />
                
                <h3>{t("permssions_title")}</h3>
                <p>{t("permssions_short")}</p>

                <Link onClick={() => navigate(-1)} className='btn'>للرجوع الى الصفحة السابقة</Link>
            </div>
        </div>
    )
}

